'use client';

import { useTranslations } from 'next-intl';
import { LoginButton } from 'components/pcc-components';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { normalizeCommerceLink, getSeoUrl } from 'utils/links';
import { B2C_LOGIN_URL } from 'constants/links';
import { useEffect, useState } from 'react';

export const SignInButton = ({
  className,
  fullWidth = true,
  variant,
  pageRedirectUrl
}: {
  className?: string;
  variant?:
    | 'primary'
    | 'contrast'
    | 'danger'
    | 'ghost'
    | 'ghost-danger'
    | 'inline';
  fullWidth?: boolean;
  pageRedirectUrl?: string;
}) => {
  const t = useTranslations();
  const [currentUrl, setCurrentUrl] = useState('');
  const [host, setHost] = useState('');
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const esiteUrl = getSeoUrl(params);
  /*
    TODO - Input Validations - usePathName: string except the
    generalRestrictedCharacters (@\constants\securityConstants.ts)
  */
  const pathname = usePathname();

  /*  TODO - Input Validations - useSearchParams: The searchParam should contain an entry with
  the key pageRedirectURL, which should be in URL format
  */
  const searchParams = useSearchParams();
  const pageRedirectUrlByParams = searchParams.get('pageRedirectUrl');
  const pageRedirectUrlByParamsWithHost =
    pageRedirectUrlByParams && `${host}${pageRedirectUrlByParams}`;

  const isHomePage = esiteUrl === pathname;
  const loginUrl = normalizeCommerceLink(
    getSeoUrl(params, B2C_LOGIN_URL, {
      pageRedirectUrl:
        pageRedirectUrl ||
        pageRedirectUrlByParamsWithHost ||
        currentUrl ||
        pathname,
      loginFromHomePage: isHomePage
    })
  );

  useEffect(() => {
    // Check if the code is running on the client side
    // Access the current page URL using window.location
    if (window.location.search) {
      setCurrentUrl(`${window.location.pathname}${window.location.search}`);
    }

    if (typeof window !== 'undefined') {
      setHost(window.location.origin);
    }
  }, []);

  return (
    <LoginButton
      variant={variant}
      className={className}
      href={loginUrl}
      fullWidth={fullWidth}
    >
      {t('SIGN_IN')}
    </LoginButton>
  );
};
